export default "__VITE_ASSET__e4523b0f__"